var _style, _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.8 26.6",
    style: {
      enableBackground: "new 0 0 50.8 26.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000016042327093997138090000010244700571704633527_);fill:#CEDC28;}\n\t.st1{fill:#808080;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "24.4,17 21.5,14.2 20.5,15.1 24.4,18.9 32.5,10.8 31.6,9.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023969732180391854280000017426272812273399726_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.9,
    style: {
      clipPath: "url(#SVGID_00000023969732180391854280000017426272812273399726_)",
      fill: "#4AAB53"
    },
    width: 14,
    height: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,24.7h14.3c6.3,0,11.4-5.1,11.4-11.4v0c0-6.3-5.1-11.4-11.4-11.4H13.2C6.9,1.9,1.8,7,1.8,13.3v0 C1.8,19.6,6.9,24.7,13.2,24.7z M27,4c5.2,0,9.4,4.2,9.4,9.4s-4.2,9.4-9.4,9.4c-5.2,0-9.4-4.2-9.4-9.4S21.8,4,27,4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle_on.8159357819ea54d2e102b437b7b0f153.svg";
export { ForwardRef as ReactComponent };